import { useEffect } from 'react'
import { LDContext, useLDClient } from 'launchdarkly-react-client-sdk'
import { useCurrentAuthenticatedUser } from '@edge/spark/io-aws'
import { useActiveAuctionId } from './useRoleCheck'
import { resetLDContextStore, getLDContextStore, setLDContextStore } from './LDContextStore'

export const useLDContext = () => {
    const ldClient = useLDClient()
    const user = useCurrentAuthenticatedUser()
    const activeAuctionId = useActiveAuctionId()

    useEffect(() => {
        if (!ldClient) {
            return
        }
        if (!user || !user?.username) {
            resetLDContextStore()
            console.log('Identifying user with context', getLDContextStore())
            ldClient.identify(getLDContextStore())
            return
        }
        if (user?.username && activeAuctionId) {
            const newContext: LDContext = {
                kind: 'multi',
                user: {
                    key: user?.username,
                },
                auction: {
                    key: activeAuctionId,
                },
            }
            setLDContextStore(newContext)
            console.log('Identifying user with context', getLDContextStore())
            ldClient.identify(getLDContextStore())
            return
        }
        if (user?.username) {
            const newContext: LDContext = {
                kind: 'user',
                key: user?.username,
            }
            setLDContextStore(newContext)
            console.log('Identifying user with context', getLDContextStore())
            ldClient.identify(getLDContextStore())
            return
        }
    }, [user?.username, activeAuctionId])
}

export default useLDContext
